<template>
	<Col>
		<Row class="title-text">Current published version</Row>
		<h5 v-if="!workflowCurrentVersion" class="description-text">This feature was never published.</h5>
		<template v-else>
			<WorkflowVersionIndication class="mb-2" :versionNumber="currentVersionNumber" />
			<h5 class="description-text">Published by {{ publishedByUserFullName }} {{ publishedTimeAgo }}</h5>
			<template v-if="doesWorkflowNeedPublish">
				<Row v-if="isLoading" class="flex-centerize with-100 mb-n3 mt-3">
					<AppLoader />
				</Row>
				<template v-else>
					<MaybeUpgradeRequiredIndicator :billingFeatureId="billingFeatureId">
						<template #default="{ indicator, isUpgradeRequired }">
							<Row>
								<h5 @click="$emit('restore-version')" class="version-link" :class="{ 'disabled-linked': isUpgradeRequired }">
									Restore version as draft
								</h5>
								<div class="pl-2" v-if="isUpgradeRequired">
									<component :is="indicator" :billingFeatureId="billingFeatureId" />
								</div>
							</Row>
						</template>
					</MaybeUpgradeRequiredIndicator>
				</template>
			</template>
		</template>
	</Col>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

import MaybeUpgradeRequiredIndicator from '@/components/Billing/MaybeUpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import WorkflowVersionIndication from '@/components/WorkflowVersionHistory/WorkflowVersionIndication.vue';
import AppAvatarService from '@/components/common/AppAvatar/app-avatar-service.js';
export default {
	name: 'WorkflowVersionHistoryMenuCurrentPublished',
	props: {
		isLoading: { type: Boolean },
		workflowCurrentVersion: { type: Object },
		workflow: { type: Object, required: true },
	},
	components: { WorkflowVersionIndication, MaybeUpgradeRequiredIndicator },
	computed: {
		...mapGetters(['user']),
		publishedByUserFullName() {
			if (this.publishedByUser.id === this.user.id) {
				return 'you';
			}
			return AppAvatarService.getUserFullName(this.publishedByUser);
		},
		publishedByUser() {
			return this.workflowCurrentVersion.published_by;
		},
		publishedTimeAgo() {
			return moment(this.workflowCurrentVersion.published_at).fromNow();
		},
		currentVersionNumber() {
			return this.workflowCurrentVersion.version || 1;
		},
		doesWorkflowNeedPublish() {
			return this.workflow.draft_pending_changes_flag;
		},
		billingFeatureId() {
			return FeatureTypes.VersionHistory;
		},
	},
};
</script>

<style scoped lang="scss">
@import '@/components/WorkflowVersionHistory/workflow-version-history-menu.scss';
.disabled-linked {
	pointer-events: none;
	opacity: 0.5;
}
</style>
